import { useEffect } from 'react';
import { useThemeStore } from '@/stores/theme';

export function useThemeInit() {
  const initTheme = useThemeStore((s) => s.initTheme);
  useEffect(() => {
    initTheme();
  }, [initTheme]);
}

export function useTheme() {
  const theme = useThemeStore((s) => s.theme);
  const toggleTheme = useThemeStore((s) => s.toggleTheme);
  const setTheme = useThemeStore((s) => s.setTheme);
  
  return { theme, toggleTheme, setTheme };
}